import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD, SORTING_OPTION } from "../../commonFields";

export const sortButtonBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Sort button",
  canHaveChildren: false,
  noWrap: true,
  inputs: [
    {
      name: "options",
      type: "list",
      subFields: [
        {
          name: "label",
          type: "string",
          localized: true,
        },
        {
          name: "ariaLabel",
          type: "string",
          localized: true,
          helperText: "ARIA label for the sorting option",
        },
        DLD_FIELD,
        DLT_FIELD,
        ...(SORTING_OPTION ?? []),
      ],
    },
    {
      name: "placeholder",
      type: "string",
      localized: true,
      required: true,
      helperText:
        "If the placeholder value is not provided, the first option is preselected.",
    },
  ],
};
